<template>
  <w-dialog :dialogShow="dialogShow" @handleClose="handleClose">
    <div slot="content" class="dialog-content">
      <div class="dialog-header flex-between">
        <span class="name">不感兴趣的原因</span>
        <span class="iconfont iconx" @click="handleClose"/>
      </div>
      <textarea v-model="reasonText" class="edit-content" placeholder="请输入您不感兴趣的原因……" type="text"/>
      <div class="reason-wrapper flex">
        <div class="reason flex-center" :class="{'reason-active': item.status}" v-for="(item, index) in reason"
             :key="index" @click="selectReason(item)">
          {{ item.name }}
        </div>
      </div>
      <div class="dialog-bottom flex-end">
        <button class="flex-center" :disabled="disabled" @click="rejectSure(reasonText)">确定</button>
      </div>
    </div>
  </w-dialog>
</template>

<script>
  import WDialog from '../../components/global/w-dialog'
	export default {
		name: 'RejectDialog',
    props: {
			dialogShow: {
				type: Boolean,
        default: false
      },
      rejectSure: {
				type: Function,
        default: () => {}
      }
    },
		data () {
			return {
				reason: [
					{ name: '对公司不感兴趣', status: false },
					{ name: '对职位不感兴趣', status: false },
					{ name: '暂不看机会', status: false }
				],
        reasonText: ''
      }
		},
		mounted () {
		},
		computed: {
			disabled () {
				return !this.reasonText
			}
    },
		watch: {},
		components: {
			WDialog
    },
		methods: {
			handleClose() {
				this.$emit('handleClose')
      },
      // 选择拒绝原因的label
			selectReason (item) {
				item.status = !item.status
				if (item.status) {
					this.reasonText += item.name + ' '
				} else {
					this.reasonText = this.reasonText.replace(new RegExp(item.name + ' ', 'gi'), '')
				}
			},
    }
	}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global/variable";
  @import "../../assets/scss/global/mixin";
  .dialog-content {
    background-color: $color-light;
    width: 90vw;
    border-radius: 2px;
    padding: 32px 24px;
    .dialog-header {
      margin-bottom: 28px;
      .name {
        font-size: $font-size-medium-x;
        font-weight: 600;
        color: $color-title;
      }
      .iconfont {
        font-weight: bold;
        font-size: $font-size-large;
        color: #8C8C8C;
      }
    }
    .edit-content {
      width: calc(100% - 32px);
      height: 82px;
      background-color: #F9F9F9;
      margin-bottom: 20px;
      border: 1px solid #dedfe1 !important;
      border-radius: 2px;
      padding: 14px;
      font-size: 14px;
      -webkit-appearance: none;
      &::placeholder {
        color: #C3C3C3;
      }
    }
    .reason-wrapper {
      flex-wrap: wrap;
      margin-bottom: 23px;
      .reason {
        height: 32px;
        padding: 0 15px;
        border: 1px solid #cfcfcf;
        color: #9C9C9C;
        margin-right: 14px;
        margin-bottom: 10px;
        border-radius: 2px;
      }
      .reason-active {
        border: 1px solid $color-theme;
        color: $color-theme;
      }
    }
    .dialog-bottom {
      button {
        width: 102px;
        height: 36px;
        font-size: $font-size-medium;
        border-radius: 2px;
        background-color: $color-theme;
        color: $color-light;
        border: none;
        outline: none;
        &:disabled {
          background-color: #C4C4C4;
        }
      }
    }
  }
</style>